<template>
  <div>
    <div class="container" ref="container" id="navBarContainer">
      <button class="navButton bgSvg" @click="toggleSwitch"></button>
      <transition name="fade">
        <div class="navs" v-if="navToggleState">
     <router-link to="/Cameras" class=" navItem camera" @click.native="toggleSwitch"><svg width="28"
      height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.003 8.8L24.465 21.722M10.997 8.8H25.921M7.994 14L15.456 1.078M10.997 19.2L3.535
 6.278M17.003 19.2H2.079M20.006 14L12.544 26.922M27 14C27 21.1797 21.1797 27 14 27C6.8203 27
 1 21.1797 1 14C1 6.8203 6.8203 1 14 1C21.1797 1 27 6.8203 27 14Z"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </router-link>
      <router-link to="devices" class=" navItem devices" @click.native="toggleSwitch">
        <svg width="28" height="23"
      viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27 11.5H1M27 11.5V19.375C27 20.0712 26.7261 20.7389 26.2385 21.2312C25.7509
 21.7234 25.0896 22 24.4 22H3.6C2.91044 22 2.24912 21.7234 1.76152 21.2312C1.27393
  20.7389 1 20.0712 1 19.375V11.5M27 11.5L22.515 2.45688C22.2997 2.01953 21.9679
   1.65149 21.5568 1.39412C21.1458 1.13675 20.6717 1.00026 20.188 1H7.812C7.32829
    1.00026 6.85424 1.13675 6.44316 1.39412C6.03207 1.65149 5.70025 2.01953 5.485
    2.45688L1 11.5M6.2 16.75H6.213M11.4 16.75H11.413"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </router-link>
      <router-link to="user" class=" navItem user" @click.native="toggleSwitch">
        <svg width="28" height="32"
       viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27 30.7143V27.4127C27 25.6614 26.3152 23.9819 25.0962 22.7435C23.8772
 21.5052 22.2239 20.8095 20.5 20.8095H7.5C5.77609 20.8095 4.12279 21.5052 2.90381
  22.7435C1.68482 23.9819 1 25.6614 1 27.4127V30.7143M20.5 7.60317C20.5 11.25 17.5899
   14.2063 14 14.2063C10.4102 14.2063 7.5 11.25 7.5 7.60317C7.5 3.95634 10.4102 1 14
    1C17.5899 1 20.5 3.95634 20.5 7.60317Z"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </router-link>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import store from '@/store/index';

function handleGlobalClick(e) {
  const container = document.getElementById('navBarContainer');
  if (!container) return;
  if (!container.contains(e.target)) store.dispatch('navToggle', false);
}

export default {
  mounted() {
    document.addEventListener('click', handleGlobalClick);
  },
  unmounted() {
    document.removeEventListener('click', handleGlobalClick);
  },
  methods: {
    toggleSwitch() {
      this.$store.dispatch('navToggle', !this.navToggleState);
    },
  },
  computed: {
    navToggleState() {
      return this.$store.state.user.navToggleState;
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: transform 0.3s, opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.navs {
  z-index: 1;
  display: flex;
  gap: 12px;
}
.container {
  position: fixed;
  bottom: 20px;
  left: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.navButton {
  z-index: 2;
  background-image: url("data:image/svg+xml,%3Csvg width='31' height='24' viewBox='0 0 31 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.77783 1.33334H29.7778Z' fill='%232C2E42'/%3E%3Cpath d='M1.77783 11.8333H29.7778Z' fill='%232C2E42'/%3E%3Cpath d='M1.77783 22.3333H29.7778Z' fill='%232C2E42'/%3E%3Cpath d='M1.77783 1.33334H29.7778M1.77783 11.8333H29.7778M1.77783 22.3333H29.7778' stroke='%23EAEBEC' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  background-color: var(--surface);
  border-radius: 100px;
  width: 64px;
  height: 64px;
}

.navItem {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 19px;
  background-color: var(--surface);
}
.navItem svg {
  stroke: var(--text);
  transition: stroke 0.2s ease;
}
.router-link-exact-active svg {
  stroke: var(--accent);
}

.navButton,
.navItem {
  box-shadow: var(--shadow);
}
</style>
